module.exports = __webpack_public_path__ + "static/media/ic-download.e9d49fbd.svg";